import { object, string, ref } from 'yup';

export const SignupSchema = object().shape({
    name: string().required("Name is required"),
    email: string().email("Enter a valid mail").required("Email is required"),
    password: string().min(6, "Password length is too short (min. 6 characters)").required("Password is required"),
    confirmPassword: string().min(6, "Password length is too short  (min. 6 characters)").oneOf([ref("password"), null], "Passwords don't match").required("Password is required"),
    role: string().required("Select a role"),
})